//export const API_BASE_URL =
//  "http://localhost:5700/api/v1/admin";

export const API_BASE_URL =
  "https://api.globalinavation.com/api/v1/admin";


export const API_PATHS = {


  userFileUpload: "/upload",

  getSelfActivateWallets: "/getSelfActivateWallets",
  userlogin: "/login",
  transferSelfActivationAmountToCompanyWallet: "/transferSelfActivationAmountToCompanyWallet",
  getSelfActivationTransferTransactions: "/getSelfActivationTransferTransactions",
  userRegister: "/register",
  changePassword: "/changePassword",

  // profile get 
  getProfile: "/get-profile",
  getDashboardSummary: "/getAdminDashboard",
  getUsers: "/get-users",
  getJoiningPaymentList: "/getJoiningPaymentList",
  approveRejectJoiningPayment: "/approveRejectJoiningPayment",
  getQr: "/get-qr",
  editQr: "/edit-qr",
  getAutoPoolStatus: "/getAutoPoolStatus",
  distributePool: "/distributePool",
  getAutoPoolUsers: "/getAutoPoolUsers",
  getAllWithdrawals: "/getAllWithdrawals",
  approveWithdrawal: "/approveWithdrawal",
  addSupportIncome: "/addSupportIncome",
  getSupportIncome: "/getSupportIncome",
  prePayAutoPool: "/prePayAutoPool",
  prepayeligible: "/auto-pool/prepay-eligible",
  edituserprofile: "/edit-user-profile",
  bulkprepay: "/auto-pool/bulk-prepay",

  getAllReferralIncome: "/getAllReferralIncome",
  getAllFundTransfers: "/getAllFundTransfers",
  getAllAutoPoolPayment: "/getAllAutoPoolPayment",


  getUserWalletTransactions: "/getUserWalletTransactions",

  // admin user ==== >
  addUser: "admin/add-user",
  gedUser: "admin/get-user",
  edidUser: "admin/edit-user",
  deletdUser: "admin/delete-user",








};
